import Vue from 'vue'

Vue.component('GoalSelectPromptContent', {
  template: `
  <div>
    <el-select v-model="targetGoalId" placeholder="Select a goal" class="w-100">
      <el-option
        v-for="goal in goal_list"
        :key="goal.$key"
        :label="goal.name || goal.cachedName"
        :value="goal.$id" />
    </el-select>
    <!-- <pre>{{targetGoalId}}</pre> -->
  </div>
  `,
  props: {
    goal_list: {}
  },
  data: () => ({
    targetGoalId: null,
  }),
  methods: {
    reset() {
      this.targetGoalId = null;
    }
  }
})

export default {
  methods: {
    $goal_prompt({ title, filterGoalId = null }) {

      let goal_list = this.$models.goalMeta.getters.all_goals_without_deleted;
      /* let goal_list = this.$models.userGoalSettings.getList().itemsAsArray() */
      goal_list = goal_list.filter( goal => goal.$id !== filterGoalId );

      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: title || 'Select a goal',
          message: this.$createElement(Vue.component('GoalSelectPromptContent'), {
            props: { goal_list }
          }),
          showCancelButton: true,
          beforeClose: (action, instance, done) => {
            let done_with_reset = () => {
              done();
              dataContainer.reset();
            }

            if ( action !== 'confirm' ) {
              done_with_reset();
              reject(new Error('cancel'));
            }

            let dataContainer = instance.$children.find( child => 'targetGoalId' in child )
            if ( !dataContainer.targetGoalId ) {
              done_with_reset();
              reject(new Error('cancel'));
            }

            resolve({ done: done_with_reset, ...dataContainer._data })
          }
        }).catch(e => e);
      });
    }
  }
}
